import React from 'react';
import { Grid } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { IconButton, Text } from 'library';

export default function BusinessJobPay({
    pay,
    rateMin,
    rateMax,
    onEdit,
}: {
    pay?: number;
    rateMin?: number;
    rateMax?: number;
    onEdit: () => void;
}) {
    return (
        <Grid xs={12} md={3} item container alignContent="flex-start">
            <Grid container item>
                <Grid xs={12} item container direction="row" style={{ gap: 10 }}>
                    <Text variant="h1">Pay Scale</Text>
                    <IconButton icon={Edit} onClick={onEdit} />
                </Grid>
                <Text>${pay ?? `${rateMin}-${rateMax}`}/hr</Text>
            </Grid>
        </Grid>
    );
}
